<template>
    <div class="nav-div w-fit sticky top-4 ml-auto flex gap-4 rounded-full p-1 md:px-6 md:py-4 z-50 right-4 md:right-28 3xl:right-[27rem] 4xl:right-[47rem]">
      <BaseButton size="custom"
        class="button-transparent rounded-full flex items-center gap-2 px-3"
        @click="changeLang()"
      >
        <i class="ri-earth-line"></i>
        {{ locale === "en" ? "Español" : "English" }}
      </BaseButton>
      <div class="nav-div mobile-nav-div flex justify-between md:gap-4 rounded-full">
        <BaseButton size="custom"
          class="button-transparent rounded-full px-3"
          @click="redirectToSignup"
        >
          {{ $t("nav.signUp") }}
        </BaseButton>
        <BaseButton size="custom" 
          class="button-yellow rounded-full shadow-none hover:shadow-sm px-3" 
          @click="redirectToDemo"
        >
          {{ $t("nav.scheduleDemo") }}
        </BaseButton>
      </div>
    </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import BaseButton from '@/components/atoms/buttons/BaseButton.vue';

const { locale } = useI18n();

const changeLang = () => {
  return (locale.value = locale.value === "en" ? "es" : "en");
};

function redirectToSignup() {
  window.open(`/register/?language=${locale.value}`, "_self");
}
function redirectToDemo() {
  window.open(
    `https://calendly.com/d/cwtn-m4d-5fm`,
    "_blank"
  );
}
</script>

<style scoped>
.nav-div {
  background-color: #e4e3e3;
}

.flex-div {
  width: 100%;
  display: flex !important;
  align-items: center;
}

button {
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
}

.button-transparent {
  height: 45px;
  background: transparent;
  color: black !important;
  font-weight: bold !important;
  text-transform: none !important;
  font-size: 16px !important;
}

.button-transparent:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.button-transparent:focus {
  background-color: #0000001b;
}

.button-yellow {
  height: 45px;
  background-color: #f7c053 !important;
  color: #69470C;
  text-transform: none !important;
  font-weight: 600;
  font-size: 16px;
}

.button-yellow:hover {
  background-color: #f5b63d !important;
}

.button-yellow:focus {
  background-color: #f5b63d !important;
}

@media (max-width: 767px) {
  .mobile-nav-div {
    position: fixed;
    bottom:0;
    left: 0;
    right: 0;
    margin: 1rem 0.5rem;
    padding: 1rem;
  }
  .mobile-nav-div button {
    height: 35px;
  }
}
</style>
